module.exports = __webpack_public_path__ + "img/31.ab6a8c59.png";